module.exports = __webpack_public_path__ + "static/img/EE.f2aa28ad.png";